<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<div class="container" (keydown)="onKeyDown($event)">
    <div class="row">
        <div class="col-24">
            <h1>My Clients</h1>
        </div>
    </div>
    <div class="row">
        <div class="col-8">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'Enter Medicare Number (without dashes)'"
                                    (onValueChange)="FmoModel.searchText = $event">
                </ValidatedTextField>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <button type="submit" class="button primary" (click)="searchByMedicare()">Search</button>
            <button id="btnBack" class="button cancel" (click)="onBack()">Back</button>
        </div>
    </div>

    <div class="row">
        <div class="col-24">
            <div class="bottom-20">
                <jqxGrid [width]="1240" [source]="dataAdapter" [columns]="columns" [autoshowcolumnsmenubutton]="false" [pageable]="false" [sortable]="true" [columnsresize]="true" [selectionmode]="'multiplecellsadvanced'" #gridReference></jqxGrid>
            </div>
        </div>
    </div>
</div>